(()=>{
 const media=matchMedia('(max-width:699px)');
 let jump;
 function update(){
  const summary=document.querySelector('.cp-random-summary');
  const selected=document.querySelectorAll('.cp-random .cp-spot[aria-pressed="true"]').length;
  if(!summary||!media.matches||!selected){if(jump)jump.hidden=true;return;}
  if(!jump){jump=document.createElement('button');jump.type='button';jump.className='cf31-mobile-selection';jump.addEventListener('click',()=>{document.querySelector('.cp-random-summary')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'center'});});document.body.append(jump);}
  const text='Voir ma sélection · '+selected;
  if(jump.textContent!==text)jump.textContent=text;
  jump.hidden=false;
 }
 new MutationObserver(update).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-pressed']});
 media.addEventListener('change',update);update();
})();

(()=>{document.querySelectorAll('.cflive-chat').forEach(chat=>{
 const head=chat.querySelector('.cflive-chat-head'),body=chat.querySelector('.cflive-messages');if(!head||!body)return;
 if(!body.id)body.id='cf31-chat-content';
 const toggle=document.createElement('button');toggle.type='button';toggle.className='cf31-chat-collapse';toggle.textContent='Réduire';toggle.setAttribute('aria-expanded','true');toggle.setAttribute('aria-controls',body.id);
 toggle.addEventListener('click',()=>{body.hidden=!body.hidden;toggle.textContent=body.hidden?'Ouvrir le chat':'Réduire';toggle.setAttribute('aria-expanded',String(!body.hidden));});
 head.append(toggle);
 matchMedia('(max-width:699px)').addEventListener('change',event=>{if(!event.matches){body.hidden=false;toggle.textContent='Réduire';toggle.setAttribute('aria-expanded','true');}});
});})();

(()=>{const live=document.querySelector('#cflive');if(!live)return;const mobile=matchMedia('(max-width:699px)');let visible=false;const update=()=>document.documentElement.classList.toggle('cf31-live-in-view',mobile.matches&&visible);new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update();},{threshold:0}).observe(live);mobile.addEventListener('change',update);})();

/* Keep mobile descriptions outside the narrow product-information column. */
(()=>{
 const media=matchMedia('(max-width:699px)'),moved=new Map();
 function arrange(){
  document.querySelectorAll('.cp-description,.cs-details').forEach(details=>{
   const hero=details.closest('.cp-detail,.cs-hero');
   if(media.matches&&hero&&!moved.has(details)){const anchor=document.createComment('product details position');details.before(anchor);moved.set(details,anchor);hero.after(details);}
  });
  if(!media.matches)moved.forEach((anchor,details)=>{anchor.replaceWith(details);moved.delete(details)});
 }
 new MutationObserver(arrange).observe(document.body,{childList:true,subtree:true});media.addEventListener('change',arrange);arrange();
})();
